/// <amd-module name="Feed/PublishedPackages/TabProvider" />
import * as React from "react";

import { ObservableArray } from "VSS/Core/Observable";
import { ITabService } from "VSS/Features/PlatformUI/ContributedTab";
import { Services, VssService, IVssPageContext } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";

import { IVssContributedTab } from "VSSUI/Tabs.Types";

import { IBuildRestClient } from "Build/Client/RestClient/Build";
import { IRunViewContributedTabProps } from "Build/Run/RunViewContributedTab";
import { PublishedPackagesTab } from "./PublishedPackagesTab";

import { BuildPackage } from "Feed/Common/Contracts/Feed";
import { DataProviderConstants, FeedServiceInstanceId } from "Feed/Common/Constants/Constants";
import { BuildStatus } from "Build/Client/Contracts/Build";

class TabProvider extends VssService implements ITabService<IRunViewContributedTabProps> {
    public getTabs(tabId: string, contextualData?: IRunViewContributedTabProps) {
        if (contextualData) {
            this._contextualData = contextualData;

            if (contextualData.status && contextualData.status.value != BuildStatus.Completed) {
                contextualData.status.subscribe(this.onBuildStatusChanged);
            } else {
                this.onBuildStatusChanged();
            }
        }

        return this._tabs;
    }

    public _serviceEnd(pageContext: IVssPageContext): void {
        this._contextualData.status.unsubscribe(this.onBuildStatusChanged);
    }

    private onBuildStatusChanged = async () => {
        // Don't do anything if tab is already present
        if (this._tabs.length == 0 && this._contextualData.status.value == BuildStatus.Completed) {
            const projectId = this._contextualData.projectId.value;
            const buildClient = this.pageContext.getRestClient<IBuildRestClient>("IBuildRestClient");
            const build = await buildClient.getBuild(projectId, this._contextualData.runId.value);

            const contributionService = this.pageContext.getService<IVssContributionService>("IVssContributionService");
            const packages = await contributionService.getDataAsync<BuildPackage[]>(
                DataProviderConstants.PackageByBuildProvider,
                { buildId: build.id },
                true /* ignoreCache */,
                FeedServiceInstanceId
            );

            if (packages && packages.length > 0) {
                this._tabs.push({
                    id: "packages-tab",
                    render: () => (
                        <div>
                            <PublishedPackagesTab packages={packages} />
                        </div>
                    ),
                    name: "Packages"
                });
            }
        }
    };

    private _contextualData: IRunViewContributedTabProps;
    private _tabs = new ObservableArray<IVssContributedTab>();
}

Services.add("published-packages.tab-provider-service", { serviceFactory: TabProvider });
